"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adminAdd = adminAdd;
exports.adminAddSync = adminAddSync;
exports.adminRemove = adminRemove;
exports.adminRemoveSync = adminRemoveSync;
exports.amendEmail = amendEmail;
exports.amendPhone = amendPhone;
exports.dataManipulation = dataManipulation;
exports.exportRecord = exportRecord;
exports.freezes = freezes;
exports.getIduser = getIduser;
exports.getLogin = getLogin;
exports.getUsercontrol = getUsercontrol;
exports.getUserid = getUserid;
exports.officialAdd = officialAdd;
exports.officialList = officialList;
exports.officialRemove = officialRemove;
var _request = _interopRequireDefault(require("@/utils/request"));
//按条件查询所有用户登录记录
function getLogin(data) {
  return (0, _request.default)({
    url: 'user/query/loginRecord',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//根据用户id查询用户信息
function getIduser(id) {
  return (0, _request.default)({
    url: 'user/query',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token'),
      "User-ID": id
    }
  });
}

//按条件查询所有用户
function getUsercontrol(data) {
  return (0, _request.default)({
    url: 'user/query/all',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//根据用户id查询用户信息(内部调用)
function getUserid(userId) {
  return (0, _request.default)({
    url: 'user/query/' + userId,
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    method: 'get'
  });
}

//修改手机号
function amendPhone(id, data) {
  return (0, _request.default)({
    url: 'user/telephone',
    method: 'put',
    headers: {
      "x-access-token": window.localStorage.getItem('token'),
      "User-ID": id,
      "from": "manage"
    },
    data: data
  });
}

//修改邮箱
function amendEmail(id, data) {
  return (0, _request.default)({
    url: 'user/email',
    method: 'put',
    headers: {
      "x-access-token": window.localStorage.getItem('token'),
      "User-ID": id,
      "from": "manage"
    },
    data: data
  });
}

//冻结或解冻用户
function freezes(data) {
  return (0, _request.default)({
    url: 'user/freeze',
    method: 'put',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//设为官方账号（resource-service，User-ID 由网关从 x-access-token 解析注入）
function officialAdd(data) {
  return (0, _request.default)({
    url: 'equipment/resource/official/add',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//取消官方账号（resource-service，User-ID 由网关从 x-access-token 解析注入）
function officialRemove(data) {
  return (0, _request.default)({
    url: 'equipment/resource/official/remove',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//查询官方账号列表（resource-service，返回官方用户 userId 集合；接口路径/方法以后端实现为准）
function officialList() {
  return (0, _request.default)({
    url: 'equipment/resource/official/list',
    method: 'get',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    }
  });
}

//设置管理员（user-service，管理员权限真源）
function adminAdd(data) {
  return (0, _request.default)({
    url: 'user/admin/add',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//撤销管理员（user-service，管理员权限真源）
function adminRemove(data) {
  return (0, _request.default)({
    url: 'user/admin/remove',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//设置管理员（resource-service 副本同步，User-ID 由网关从 x-access-token 解析注入）
function adminAddSync(data) {
  return (0, _request.default)({
    url: 'equipment/resource/admin/add',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//撤销管理员（resource-service 副本同步，User-ID 由网关从 x-access-token 解析注入）
function adminRemoveSync(data) {
  return (0, _request.default)({
    url: 'equipment/resource/admin/remove',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

//登录设备统计报表
function exportRecord(data) {
  return (0, _request.default)({
    url: 'user/export/login/record',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    responseType: 'blob',
    timeout: 360000,
    data: data
  });
}

/**
 * 前端刷新公共方法
 */
function dataManipulation(tableData, rowData, telephone, email, isNormal) {
  tableData.map(function (element) {
    rowData.map(function (row) {
      //如果是单选的直接用if判断id是否相等就可以了,如果是复选框的就需要嵌套for循环判断
      if (element.userId == row.userId) {
        if (telephone != null && telephone != "") {
          element.telephone = telephone;
        }
        if (email != null && email != "") {
          element.email = email;
        }
        if (isNormal != null && isNormal != "") {
          element.isNormal = isNormal;
        }
      }
    });
  });
  return tableData;
}